import { render, staticRenderFns } from "./AppMovilHistorial.vue?vue&type=template&id=3d646dd8&"
import script from "./AppMovilHistorial.vue?vue&type=script&lang=js&"
export * from "./AppMovilHistorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports